/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import proptypes from 'prop-types';
import Select from 'react-select';
import { getSelectedValue } from './findSelection';

export default function SelectWithDefault({
  handleChange,
  isInvalid,
  name,
  options,
  value,
  isClearable = true,
  isDisabled = false,
  isLoading = false,
  formatOptionLabel = undefined,
  ...delegated
}) {
  const selectedValue = getSelectedValue(options, value);
  return (
    <Select
      isLoading={isLoading}
      value={selectedValue}
      isClearable={isClearable}
      classNames={{
        control: () =>
          isInvalid ? 'form-control p-0 pe-4 is-invalid' : 'form-control p-0',
      }}
      options={options}
      placeholder={isLoading ? 'Loading...' : 'Select an option'}
      aria-label={name}
      id={name}
      classNamePrefix="lb_select"
      onChange={(e, action) => {
        handleChange(e, action);
      }}
      formatOptionLabel={formatOptionLabel}
      menuPlacement="auto"
      isDisabled={isDisabled}
      {...delegated}
    />
  );
}

SelectWithDefault.propTypes = {
  options: proptypes.arrayOf(proptypes.object.isRequired),
  value: proptypes.oneOfType([proptypes.string, proptypes.number]),
  handleChange: proptypes.func.isRequired,
  isInvalid: proptypes.bool,
  name: proptypes.string.isRequired,
  isClearable: proptypes.bool,
  isDisabled: proptypes.bool,
  isLoading: proptypes.bool,
  formatOptionLabel: proptypes.func,
};

SelectWithDefault.defaultProps = {
  value: '',
  options: [],
  isInvalid: false,
};
